import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CarePathwayStep } from '../../../../services/result-data/result-data.service';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { SelectedStepService } from '../../../../services/selected-step/selected-step.service';
import { imageToggle, descriptionExpand } from './care-pathway.animations';
import { CarePathwayStepperComponent } from '../care-pathway-stepper/care-pathway-stepper.component';
import { TransitionService } from '../../../../services/transition/transition.service';

@Component({
  selector: 'app-care-pathway',
  imports: [
    CommonModule,
    MatIconModule,
    MatButtonModule,
    CarePathwayStepperComponent,
  ],
  templateUrl: './care-pathway.component.html',
  styleUrl: './care-pathway.component.scss',
  animations: [imageToggle, descriptionExpand],
})
export class CarePathwayComponent {
  @Input() carePathwaySteps: CarePathwayStep[] = [];

  showDescriptions = false;

  constructor(
    private readonly _selectedStepService: SelectedStepService,
    private readonly _transitionService: TransitionService
  ) {}

  onClickToggleExpand(): void {
    this.showDescriptions = !this.showDescriptions;
  }

  onClickStep(stepIndex: number): void {
    this._transitionService.run(() =>
      this._selectedStepService.selectStep(stepIndex)
    ); // +++
  }

  resetView(): void {
    this.showDescriptions = false;
  }
}
